import {
  DEFAULT_GUTTER_WIDTH_DESKTOP,
  DEFAULT_GUTTER_WIDTH_MOBILE,
} from "../../constants/ui";
const PageTitle = ({
  superscriptText,
  adjacentContent,
  centerContent,
  title,
  titleIcon,
  subtitle,
  description,
  rightSideContent,
  isCondensed = false,
  isUseGutters = false,
  className = "",
}: {
  title: string | React.ReactNode;
  titleIcon?: React.ReactNode;
  superscriptText?: string;
  adjacentContent?: React.ReactNode;
  centerContent?: React.ReactNode;
  subtitle?: string;
  description?: React.ReactNode;
  rightSideContent?: React.ReactNode;
  isCondensed?: boolean;
  isUseGutters?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={`page-title min-h-[50px] flex justify-between items-center px-[${
        !isUseGutters ? 0 : DEFAULT_GUTTER_WIDTH_MOBILE
      }px] md:px-[${!isUseGutters ? 0 : DEFAULT_GUTTER_WIDTH_DESKTOP}px] ${className}`}
    >
      <div className="page-title-left flex flex-col">
        <div className="flex items-baseline gap-3">
          <div className="flex flex-row items-center gap-2">
            {titleIcon && <div className={subtitle ? "self-end" : ""}>{titleIcon}</div>}
            <div className="flex flex-col">
              {subtitle && (
                <div className="subtitle text-sm text-primary font-semibold leading-none">
                  {subtitle}
                </div>
              )}
              <h1 className="page-title-text font-bold text-xl whitespace-nowrap leading-none">
                {title}{" "}
                {superscriptText && (
                  <sup
                    className={`text-[15px] md:text-[${
                      isCondensed ? 10 : 15
                    }px] relative top-[-5px] text-gray-secondary right-[4px]`}
                  >
                    {superscriptText}
                  </sup>
                )}
              </h1>
            </div>
          </div>
          <div>{adjacentContent}</div>
        </div>
        {description && (
          <p className="text-gray-secondary text-sm mt-1">{description}</p>
        )}
      </div>
      <div>{centerContent}</div>
      <div>{rightSideContent}</div>
      
    </div>
  );
};

export default PageTitle;
